import { some } from 'lodash/fp';

const shouldDisplayAlternateCustodyChildren = (children = []) =>
    some(({ situation }) => 'alternate_custody' === situation, children);

export default shouldDisplayAlternateCustodyChildren;
